import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from "./router/index";
// import Global from "./assets/Global";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入echarts
// import echarts from 'echarts'
import * as echarts from 'echarts';
import './assets/icon/iconfont.css'
import './common/rem'
Vue.prototype.$echarts = echarts
Vue.prototype.$store = store

Vue.config.productionTip = false
// 将全局变量挂载到项目内
// Vue.prototype.GLOBAL = Global

Vue.use(ElementUI)
// Vue.use(store)

Vue.directive('no-swipe', {
  bind(el, binding){
    el.addEventListener('touchmove', (event) => {
      if(binding.value){    // 如果绑定的是true,则禁止滑动
        event.preventDefault()
      }
    }, { passive: false })  // passive选项设置为false以启用preventDefault()调用
  },
  unbind(el){
    el.removeEventListener('touchmove')// 移除事件监听器以避免内存泄漏
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')





